export default __webpack_public_path__ + "static/media/hospital.6965479c.png";